var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg18PxCalendar = function Svg18PxCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#56565C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M5.75 2.75v-2M12.25 2.75v-2M13.75 2.75h-9.5a2 2 0 0 0-2 2v8.5a2 2 0 0 0 2 2h9.5a2 2 0 0 0 2-2v-8.5a2 2 0 0 0-2-2M2.25 6.25h13.5"
  })));
};
export default Svg18PxCalendar;